import { createFileRoute } from "@tanstack/react-router";
import useFonts from "@/components/Fonts/useFonts";
import { Root } from "@/components/Root";

export const Route = createFileRoute("/$organizationKey/$dossierId/$researchProjectId/")({
  component: DashboardPage,
});

function DashboardPage() {
  const { researchProjectId } = Route.useParams();
  useFonts();
  return <Root researchProjectId={Number.parseInt(researchProjectId)} />;
}
